import Alert, { type AlertTypes } from './Alert';

export type { AlertTypes };
export default Alert;
